import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProducersService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getByMunicipalityKey(municipalityKey: string) {
    return of([]);
  }

  public getById(id: number) {
    return of(null);
  }

  public updateDetails(id: number, details: any) {
    return of(null);
  }

  public updatePerformance(id: number, details: any) {
    return of(null);
  }

  public getProducersByMunicipalityKey(municipalityKey: string): Observable<any[]> {
    const url = `socrates/meters/api/municipalities/${municipalityKey}/producers?$expand=AssetType($select=name,imageName,code)&$filter=nominalGeneratorPower ge 30 and AssetType/Code in ('PRD-WIND', 'PRD-PV', 'PRD-WATER', 'PRD-BIOMASS')&$select=producerGuid,externalProducerId,connectionObjectNumber,district,zipcode,street,houseNumber,latitude,longitude,dsoidentifier,nominalGeneratorPower,inOperationDate`;

    return this.http.get<any[]>(this.endpoint(url));
  }
}
